module.exports = __webpack_public_path__ + "img/item_Story_19.18645a13.jpeg";